const checkboxes = document.querySelectorAll(".custom-checkbox-container"),

      subTotalProductsEl = document.querySelector(".bought-together__summary__note__product-name"),
      selectedProductNames = document.querySelectorAll(".bought-together__product__details__name"),
      subTotalProductNamesContainer = document.querySelector(".bought-together__summary__note"),

      productPrices = document.querySelectorAll(".bought-together__product__details__price"),
      subTotalPriceEl = document.querySelector(".bought-together__summary__price__value"),
      
      goToCheckoutBtn = document.querySelector(".go-to-checkout");

let subTotal = 0,
    listOfProducts = [];

export default function init() {

  checkboxes.forEach((checkbox, index) => {
    checkbox.addEventListener("click", (e) => {
      isBoxChecked(e, index);
    });
  });

  function isBoxChecked(e, index) {
    let checkedStatus = e.target.checked;
    if (checkedStatus !== undefined) {
      updateSubtotal(index, checkedStatus);
      handleSubtotalProductNames(selectedProductNames[index].innerHTML,checkedStatus);
    }
  }

  function updateSubtotal(index, checkedStatus) {
    let selectedProdPrice = parseInt(productPrices[index].dataset.productPrice);
    checkedStatus ? (subTotal += selectedProdPrice) : (subTotal -= selectedProdPrice);
    subTotalPriceEl.innerHTML = subTotal / 100;
  }

  function handleSubtotalProductNames(prodName, checkedStatus) {
    checkedStatus ? addProdToList(prodName) : removeProdFromList(prodName);

    function addProdToList(prodName) {
      listOfProducts.push(prodName);
      updateProductNames();
    }

    function removeProdFromList(prodName) {
      listOfProducts.indexOf(prodName) > -1 ? listOfProducts.splice(listOfProducts.indexOf(prodName), 1) : console.log("nothing to remove");
      updateProductNames();
    }

    function updateProductNames() {
      console.log(listOfProducts);
      if (listOfProducts.length > 1) {
        subTotalProductNamesContainer.style.display = "block";
        subTotalProductsEl.innerHTML = listOfProducts.join(" and ");
      } else if (listOfProducts.length === 1) {
        subTotalProductNamesContainer.style.display = "block";
        subTotalProductsEl.innerHTML = listOfProducts.join("");
      } else if (listOfProducts.length <= 0) {
        subTotalProductNamesContainer.style.display = 'none';
      }
    }
  }

}